import { render, staticRenderFns } from "./BtnToDetalhar.vue?vue&type=template&id=109e4a8b"
import script from "./BtnToDetalhar.vue?vue&type=script&lang=js"
export * from "./BtnToDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports